import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RutService {

  constructor() { }

  RutEsValido(rut) {
    if (!rut || rut.trim().length < 3) return false;
    const rutLimpio = rut.replace(/[^0-9kK-]/g, "");

    if (rutLimpio.length < 3) return false;

    const split = rutLimpio.split("-");
    if (split.length !== 2) return false;

    const num = parseInt(split[0], 10);
    const dgv = split[1];

    const dvCalc = this.CalculateDV(num);
    return dvCalc === dgv;
  }

  CalculateDV(rut) {
    const cuerpo: any = `${rut}`;
    // Calcular Dígito Verificador
    let suma = 0;
    let multiplo = 2;

    // Para cada dígito del Cuerpo
    for (let i = 1; i <= cuerpo.length; i++) {
      // Obtener su Producto con el Múltiplo Correspondiente
      const index = multiplo * cuerpo.charAt(cuerpo.length - i);

      // Sumar al Contador General
      suma += index;

      // Consolidar Múltiplo dentro del rango [2,7]
      if (multiplo < 7) {
        multiplo += 1;
      } else {
        multiplo = 2;
      }
    }

    // Calcular Dígito Verificador en base al Módulo 11
    const dvEsperado = 11 - (suma % 11);
    if (dvEsperado === 10) return "k";
    if (dvEsperado === 11) return "0";
    return `${dvEsperado}`;
  }

  AgregarDV(rut) {
    const dv = this.CalculateDV(rut);
    return `${rut}${dv}`;
  }

  QuitarDV(rutConDv) {
    if (rutConDv.length >= 2) {
      return Number(rutConDv.slice(0, rutConDv.length - 1))
    }
    return Number(rutConDv)
  }

  Limpiar(rut: any) {
    if (!rut)
      return ''
    return rut.replaceAll('.', '').replace('-', '').trim()
  }

}
